import * as React from 'react'

import { AddonDetailProvider } from '~shared/segments/AddonDetail'

import { StickyStateProvider } from '../../../components/Sticky/StickyStateProvider'
import { LayoutProvider } from '../../../config/contexts/LayoutProvider'
import { ProductDetailStateProvider } from '../contexts/ProductDetailStateProvider'
import { TProductDetailOverlay } from '../types'
import { ProductDetailOverlayDrawer } from './ProductDetailOverlayDrawer'
import { ProductDetailOverlayModal } from './ProductDetailOverlayModal'

type TExtraModalProps = Pick<PropsOf<typeof ProductDetailOverlayModal>, 'modalBodySpacing'>
type TStateProviderProps = Pick<PropsOf<typeof ProductDetailStateProvider>, 'selectedLanguage'>

type TProps = NoChildren &
  TStateProviderProps &
  TProductDetailOverlay &
  TExtraModalProps & {
    isMobile: boolean
    isTablet: boolean
  }

/**
 * Overlay component for product detail.
 * Renders either modal or drawer based on the device type.
 */
export const ProductDetailOverlay: React.FC<TProps> = ({
  isMobile,
  isTablet,
  selectedLanguage,
  ...props
}) => {
  const OverlayComponent = React.useMemo(
    () => (isMobile ? ProductDetailOverlayDrawer : ProductDetailOverlayModal),
    [isMobile],
  )

  return (
    <LayoutProvider isMobile={isMobile} isTablet={isTablet}>
      <StickyStateProvider>
        <ProductDetailStateProvider selectedLanguage={selectedLanguage}>
          <AddonDetailProvider>
            <OverlayComponent {...props} />
          </AddonDetailProvider>
        </ProductDetailStateProvider>
      </StickyStateProvider>
    </LayoutProvider>
  )
}
